export const formatFileName = (f) => {
  if(!f) return "";
  const spl = f.split(".");
  const name = spl[0],
    ext = spl[1];
  const short = name.slice(0, 20);
  
  return `${short}${short.length < name.length ? "..." : ""}.${ext}`;
};